import { useEffect, useState } from 'react';

/**
 * Hook optimisé pour détecter le scroll avec debounce
 * Réduit drastiquement les re-renders lors du scroll
 */
export function useScrollDebounce(threshold: number = 50, delay: number = 100) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            setIsScrolled(window.scrollY > threshold);
          }, delay);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Check initial state
    setIsScrolled(window.scrollY > threshold);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timeoutId);
    };
  }, [threshold, delay]);

  return isScrolled;
}